import type { Klass, LexicalNode, EditorThemeClasses } from 'lexical';
import { ListNode, ListItemNode } from '@lexical/list';
import { LinkNode } from '@lexical/link';

/** Figma's composer toolbar (Bold/Italic/Underline/link/list) is a small,
 *  deliberate subset of scriptDoc's — no headings, code, tables or color, so
 *  this is its own node set/theme rather than reusing scriptDoc's config.
 *  No AutoLinkNode: links are only ever created explicitly via the toolbar's
 *  Link button, no typed-URL auto-linkify (that would need its own plugin +
 *  matcher, which nothing here wires up). */
export const COMPOSER_NAMESPACE = 'outreach-composer';

export const COMPOSER_NODES: ReadonlyArray<Klass<LexicalNode>> = [ListNode, ListItemNode, LinkNode];

export const composerTheme: EditorThemeClasses = {
  paragraph: 'my-1 last:mb-0 first:mt-0',
  list: {
    ul: 'my-1 list-disc pl-6',
    ol: 'my-1 list-decimal pl-6',
    listitem: 'my-0.5',
  },
  link: 'text-primary underline',
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
  },
};
